import React from "react"
import DateHelper from "../../DateHelper/DateHelper"

export default class CampaignScheduleDataType extends React.Component{

  render() {
    if (this.props.data) {
      var list_items = []
      
      Object.keys(this.props.data).map((ece, idx) => {
        list_items.push(<li key={idx}>{this.props.data[ece].email} - {DateHelper.printDateToScreen(DateHelper.local(this.props.data[ece].date), this.props.date_format)} {this.props.row.sent_emails && this.props.row.sent_emails.includes(this.props.data[ece].email) ? `(${I18n.t("completed")})` : `(${I18n.t("pending")})`}</li>)
      })

      return <ul>{list_items}</ul>
    } else {
      return (
        <em className="text-center">&nbsp;</em>
      );
    }
  }

};